export default {
  'Teklif Formu': 'Formulario de Cotización',
  'Kayıtlı Teklifler': 'Cotizaciones Guardadas',
  'Kullanıcı Adı': 'Nombre de Usuario',
  'Şifre': 'Contraseña',
  'Giriş Yap': 'Iniciar Sesión',
  'Çıkış Yap': 'Cerrar Sesión',
  'KDV Oranı': 'Tasa de IVA',
  'Teklif Durumu': 'Estado de Cotización',
  'Kaydet': 'Guardar',
  'PDF Önizleme': 'Vista Previa PDF',
  'PDF\'ye Aktar': 'Exportar a PDF',
  'E-posta ile Gönder': 'Enviar por Email',
  'Alıcı': 'Destinatario',
  'Tarih': 'Fecha',
  'Genel Toplam': 'Total General',
  'Not': 'Nota',
  'KDV': 'IVA',
  'Alt Toplam': 'Subtotal',
  'Açıklama': 'Descripción',
  'Ürün Adı': 'Nombre del Producto',
  'SUT Kodu': 'Código SUT',
  'Birim Alış Fiyatı': 'Precio Unitario',
  'Sipariş Adedi': 'Cantidad de Pedido',
  'Promosyon Ürün': 'Producto Promocional',
  'Toplam Adet': 'Cantidad Total',
  'Sipariş Tutarı': 'Total del Pedido',
  'Durum': 'Estado',
  'Kabul Edildi': 'Aceptado',
  'Reddedildi': 'Rechazado',
  'Gönderildi': 'Enviado',
  'Taslak': 'Borrador',
  'Yurtiçi': 'Nacional',
  'Yurtdışı': 'Internacional',
  'Sipariş Oluştur': 'Crear Pedido',
  'Ürün Sıralaması': 'Ordenamiento de Productos',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Los productos están ordenados por popularidad e importancia',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Los productos de cardiología y cirugía vascular se muestran como prioridad',
  'Ürün adı, açıklama veya barkod ile ara...': 'Buscar por nombre de producto, descripción o código de barras...',
  'Tüm Kategoriler': 'Todas las Categorías',
  'Kutu görünüm': 'Vista de cuadrícula',
  'Liste görünüm': 'Vista de lista',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'No se encontraron productos que coincidan con sus criterios',
  'Ürün Adı Yok': 'Sin Nombre de Producto',
  'Kategori Yok': 'Sin Categoría',
  'Açıklama yok': 'Sin descripción',
  'Firma Bilgilerini Doldurun': 'Completar Información de la Empresa',
  'Sepete Ekle': 'Agregar al Carrito',
  'Firma Bilgileri': 'Información de la Empresa',
  'Ülke Seçimi': 'Selección de País',
  'Türkiye': 'Turquía',
  'Almanya': 'Alemania',
  'ABD': 'EE.UU.',
  'Firma Ünvanı': 'Nombre de la Empresa',
  'Vergi Dairesi': 'Oficina de Impuestos',
  'Vergi Numarası': 'Número de Impuestos',
  'Adres': 'Dirección',
  'Şehir': 'Ciudad',
  'Şehir Seçimi': 'Selección de Ciudad',
  'Şehir Seçiniz': 'Seleccionar Ciudad',
  'Şehir adı ara...': 'Buscar nombre de ciudad...',
  'Aradığınız şehir bulunamadı': 'Ciudad no encontrada',
  'Bu ülke için şehir verisi bulunamadı': 'No hay datos de ciudades disponibles para este país',
  'şehir bulundu': '{{count}} ciudades encontradas',
  'Yetkili': 'Persona Autorizada',
  'Telefon': 'Teléfono',
  'Email': 'Email',
  'Bilgileri İlet': 'Enviar Información',
  'Lütfen eksik alanları doldurun': 'Por favor complete los campos faltantes',
  'Firma kaydedilemedi': 'La empresa no se pudo guardar',
  'Firma bilgileri başarıyla iletildi': 'Información de la empresa enviada exitosamente',
  'Firma Ünvanı:': 'Nombre de la Empresa:',
  'Yetkili Kişi:': 'Persona Autorizada:',
  'Sepetiniz': 'Su Carrito',
  'Sepetiniz boş': 'Su carrito está vacío',
  'adet': 'pcs',
  'Düzenle': 'Editar',
  'Kaldır': 'Eliminar',
  'Siparişi Tamamla': 'Completar Pedido',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Por favor envíe la información completa de su empresa primero',
  'Sipariş başarıyla kaydedildi': 'Pedido guardado exitosamente',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Mensaje de bienvenida y enlace de acceso enviado a su email',
  'Link 3 gün geçerlidir': 'El enlace es válido por 3 días',
  'Sipariş kaydedilemedi': 'El pedido no se pudo guardar',
  'Firma Bilgileri Gerekli': 'Información de Empresa Requerida',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Complete la información de la empresa primero para agregar al carrito',
  'Önce Bilgileri Doldurun': 'Complete la Información Primero',
  'Uyarı': 'Advertencia',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Debe completar la información de la empresa primero para agregar al carrito',
  'SUT Kütüphanesi Tanımı': 'Definición de Biblioteca SUT',
  'SUT Kodu:': 'Código SUT:',
  'Standart': 'Estándar',
  'Açıklama (isteğe bağlı)': 'Descripción (opcional)',
  'Partner Ol': 'Convertirse en Partner',
  'Partner başvuru popup açılacak': 'Se abrirá el popup de solicitud de partner',
  'Dil': 'Idioma',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Contraseña',
  'Şifremi Unuttum': 'Olvidé mi Contraseña',
  'Giriş yapılıyor...': 'Iniciando sesión...',
  'E-posta veya şifre hatalı': 'Email o contraseña incorrectos',
  'Şifre sıfırlama e-postası gönderildi': 'Email de restablecimiento de contraseña enviado',
  'E-posta gönderilemedi': 'No se pudo enviar el email',
  'Üye Ol': 'Registrarse',
  'Üye Değil Misiniz?': '¿No es miembro?',
  'Şimdi Üye Ol': 'Registrarse Ahora',
  'Misafir Kullanıcı': 'Usuario Invitado',
  'Hızlı Sipariş': 'Pedido Rápido',
  'Misafir Olarak Sipariş Verin': 'Pedir como Invitado',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Seleccione rápidamente sus productos y cree su pedido sin iniciar sesión',
  'Giriş yapmadan sipariş oluşturun': 'Crear pedido sin iniciar sesión',
  'Anında Erişim': 'Acceso Instantáneo',
  'Tüm ürünlere anında erişim': 'Acceso instantáneo a todos los productos',
  'Güvenli İşlem': 'Transacción Segura',
  'SSL korumalı güvenli sipariş': 'Pedido seguro protegido por SSL',
  'Misafir Olarak Sipariş Oluştur': 'Crear Pedido como Invitado',
  'İpucu:': 'Consejo:',
  'Daha fazla özellik için üye olun': 'Regístrese para más funciones',
  'Ücretsiz': 'Gratis',
  'Hızlı': 'Rápido',
  'Güvenli': 'Seguro',
  'bayilikSozlesme': 'He leído y acepto los términos y condiciones de asociación de INVAMED.',
  'geri': 'Atrás',
  'basvuruGonder': 'Enviar Solicitud',
  'ileri': 'Siguiente',
  'sozlesmeGonderildi': '¡Contrato Enviado a su Email!',
  'sozlesmeDesc': 'Por favor suba el Contrato de Asociación INVAMED y los documentos requeridos enviados a su dirección de email a continuación.',
  'tamamla': 'Completar Solicitud',
  'basvuruAlindi': '¡Su Solicitud Ha Sido Recibida!',
  'basvuruAlindiDesc': 'El equipo de INVAMED revisará su solicitud y se pondrá en contacto con usted lo antes posible.',
  'Başvuru Durumu': 'Estado de la solicitud',
  'Başvurunuz onay sürecindedir': 'Su solicitud está siendo revisada',
  'sifreSifirla': 'Restablecer Contraseña',
  'sifreSifirlaDesc': 'Ingrese su dirección de email registrada y le enviaremos instrucciones para restablecer su contraseña.',
  'gonder': 'Enviar',
  'talimatGonderildi': 'Instrucciones Enviadas',
  'sentDesc': 'Las instrucciones para restablecer la contraseña han sido enviadas a <b>{email}</b>. Por favor revise su email.',
  'helpTitle': '¿Cómo puedo iniciar sesión?',
  'helpList': [
    'Para iniciar sesión en el panel de distribuidores INVAMED, ingrese su dirección de email registrada y contraseña.',
    'Para iniciar sesión con el usuario demo:',
    'Si olvidó su contraseña, use el enlace "Olvidé mi Contraseña" para solicitar un restablecimiento.',
    'Si tiene problemas para iniciar sesión, asegúrese de que su email y contraseña sean correctos. Si el problema persiste, contacte a nuestro equipo de soporte.'
  ],
  'partnerlikSozlesmeTitle': 'Acuerdo de Asociación INVAMED y Términos',
  'partnerlikSozlesmeText': `1. DISPOSICIONES GENERALES

Este acuerdo se celebra entre INVAMED (en adelante referido como "Empresa") y el candidato a partner (en adelante referido como "Partner") con el propósito de cooperación en la venta de dispositivos médicos y equipos.

2. CONDICIONES DE ASOCIACIÓN

2.1. El Partner debe tener autoridad legal para la venta de dispositivos médicos.
2.2. El Partner debe ser una organización que opere en el sector de la salud.
2.3. El Partner debe tener las licencias y certificados necesarios.
2.4. El Partner debe ser financieramente confiable.

3. OBLIGACIONES DE LAS PARTES

Obligaciones de la Empresa:
3.1. Proporcionar productos y servicios de calidad
3.2. Proporcionar soporte técnico
3.3. Proporcionar capacitación e información
3.4. Ser transparente sobre precios

Obligaciones del Partner:
3.1. Almacenar productos en condiciones apropiadas
3.2. Proporcionar servicio al cliente de calidad
3.3. Cumplir con regulaciones legales
3.4. Proteger la marca de la empresa

4. FIJACIÓN DE PRECIOS Y PAGO

4.1. Los precios son determinados por la Empresa
4.2. El Partner está obligado a mantener los precios determinados
4.3. Los términos de pago se determinan por separado
4.4. Las tasas de comisión pueden variar según el rendimiento

5. CONFIDENCIALIDAD Y SEGURIDAD

5.1. Las partes están obligadas a proteger la información confidencial de cada una
5.2. La información del cliente debe mantenerse confidencial
5.3. Se deben cumplir los estándares de seguridad de datos

6. DURACIÓN Y TERMINACIÓN DEL ACUERDO

6.1. Este acuerdo es válido por 1 año
6.2. Puede extenderse por acuerdo mutuo
6.3. Puede terminarse con 30 días de aviso
6.4. Puede terminarse inmediatamente en caso de violación grave

7. RESOLUCIÓN DE DISPUTAS

7.1. Las disputas se intentan resolver principalmente a través de negociación
7.2. Los tribunales de la República de Turquía están autorizados para casos no resueltos

8. EFECTIVIDAD

Este acuerdo ha sido leído, entendido y aceptado por las partes.`,
  'partnerlikSozlesmeOnay': 'He leído, entendido y acepto el Acuerdo de Asociación INVAMED y Términos anteriores. Declaro que acepto todos los artículos de este acuerdo y cumpliré mis obligaciones.',
  'sozlesmeyiGoruntule': 'Ver Acuerdo',
  'sozlesmeyiKapat': 'Cerrar',
  'Ürün': 'Producto',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Seleccione productos de la lista para agregar al carrito',
  'Etiketler': 'Etiquetas',
  'Öncelikli': 'Prioridad',
  'Kapat': 'Cerrar',
  'globalPartnersTitle': 'Colaborando con 30,000 Partners en Todo el Mundo',
  'globalPartnersDesc': 'Nuestra extensa red global de 30,000 partners impulsa la innovación compartida, el intercambio de conocimientos y el éxito mutuo. Trabajando juntos, expandimos continuamente las fronteras del cuidado del paciente.',
  'Yardım': 'Ayuda',
  'dil': 'Idioma',
  'Connect Free!': '¡Conéctate gratis!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Descubre nuestros productos más populares',
  'Tüm Kategoriler': 'Todas las categorías',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 productos mostrados (Total: 8000+)',
  'Tüm Ürünleri Gör →': 'Ver todos los productos →',
  'Detaylar': 'Detalles',
  'Sipariş Ver': 'Ordenar',
  'Giriş Yap': 'Iniciar sesión',
  'Hesabınıza giriş yapın': 'Inicia sesión en tu cuenta',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Este sitio está protegido por reCAPTCHA y se aplican la Política de privacidad y los Términos de servicio de Google.',
  'Ürün Kataloğumuz': 'Nuestro catálogo de productos',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Ofrecemos más de 8000 productos',
  '1,3B': '1,3K',
  'Partner': 'Socio',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Producción total',
  '23': '23',
  'Branş': 'Rama',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Pedidos totales',
  'Connect Now': 'Conectar ahora',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Regístrate gratis para acceder a toda la información en un solo lugar.',
  'Ürün Detayları': 'Detalles del producto',
  'Kapat': 'Cerrar',
  'Yükleniyor...': 'Cargando...',
  'Hata': 'Error',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} productos mostrados (Total: 8000+)',
  'Şehir Seçimi': 'Selección de Ciudad',
  'Firma / Sağlık Profesyoneli': 'Empresa / Profesional de Salud',
  'Yetkili Kişi': 'Persona Autorizada',
  'Telefon': 'Teléfono',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Información Básica',
  'Ek Bilgiler': 'Información Adicional',
  'Faaliyet Alanı / Sektör': 'Área de Actividad / Sector',
  'Ülke Seçimi': 'Selección de País',
  'Ülke adı veya kodu ara...': 'Buscar nombre o código de país...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'América',
  'region.Asya': 'Asia',
  'region.Afrika': 'África',
  'region.Okyanusya': 'Oceanía',
  'region.Diğer': 'Otro',
  'country.TR': 'Turquía',
  'country.US': 'Estados Unidos',
  'country.DE': 'Alemania',
  'country.FR': 'Francia',
  'country.GB': 'Reino Unido',
  'country.IT': 'Italia',
  'country.ES': 'España',
  'country.RU': 'Rusia',
  'country.CN': 'China',
  'country.JP': 'Japón',
  'country.KR': 'Corea del Sur',
  'country.IN': 'India',
  'country.BR': 'Brasil',
  'country.CA': 'Canadá',
  'country.AU': 'Australia',
  'Ticaret Sicil No': 'Número de Registro Mercantil',

  'country.TR': 'Turquía',
  'country.AL': 'Albania',
  'country.DE': 'Alemania',
  'country.AD': 'Andorra',
  'country.AT': 'Austria',
  'country.BY': 'Bielorrusia',
  'country.BE': 'Bélgica',
  'country.BA': 'Bosnia y Herzegovina',
  'country.BG': 'Bulgaria',
  'country.CZ': 'República Checa',
  'country.DK': 'Dinamarca',
  'country.EE': 'Estonia',
  'country.FO': 'Islas Feroe',
  'country.FI': 'Finlandia',
  'country.FR': 'Francia',
  'country.GI': 'Gibraltar',
  'country.GR': 'Grecia',
  'country.GG': 'Guernsey',
  'country.HR': 'Croacia',
  'country.NL': 'Países Bajos',
  'country.IE': 'Irlanda',
  'country.ES': 'España',
  'country.SE': 'Suecia',
  'country.CH': 'Suiza',
  'country.IT': 'Italia',
  'country.IS': 'Islandia',
  'country.JE': 'Jersey',
  'country.ME': 'Montenegro',
  'country.LV': 'Letonia',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Lituania',
  'country.LU': 'Luxemburgo',
  'country.HU': 'Hungría',
  'country.MT': 'Malta',
  'country.IM': 'Isla de Man',
  'country.MD': 'Moldavia',
  'country.MC': 'Mónaco',
  'country.MK': 'Macedonia del Norte',
  'country.NO': 'Noruega',
  'country.PL': 'Polonia',
  'country.PT': 'Portugal',
  'country.RO': 'Rumania',
  'country.RU': 'Rusia',
  'country.SM': 'San Marino',
  'country.RS': 'Serbia',
  'country.SK': 'Eslovaquia',
  'country.SI': 'Eslovenia',
  'country.SJ': 'Svalbard y Jan Mayen',
  'country.UA': 'Ucrania',
  'country.GB': 'Reino Unido',
  'country.VA': 'Ciudad del Vaticano',
  'country.AX': 'Islas Åland',
  'country.US': 'Estados Unidos',
  'country.AS': 'Samoa Americana',
  'country.AI': 'Anguila',
  'country.AG': 'Antigua y Barbuda',
  'country.AR': 'Argentina',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbados',
  'country.BZ': 'Belice',
  'country.BM': 'Bermudas',
  'country.BO': 'Bolivia',
  'country.BR': 'Brasil',
  'country.VG': 'Islas Vírgenes Británicas',
  'country.CA': 'Canadá',
  'country.KY': 'Islas Caimán',
  'country.CL': 'Chile',
  'country.CO': 'Colombia',
  'country.CR': 'Costa Rica',
  'country.CU': 'Cuba',
  'country.CW': 'Curazao',
  'country.DM': 'Dominica',
  'country.DO': 'República Dominicana',
  'country.EC': 'Ecuador',
  'country.SV': 'El Salvador',
  'country.FK': 'Islas Malvinas',
  'country.GF': 'Guayana Francesa',
  'country.GD': 'Granada',
  'country.GL': 'Groenlandia',
  'country.GP': 'Guadalupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaica',
  'country.MQ': 'Martinica',
  'country.MX': 'México',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicaragua',
  'country.PA': 'Panamá',
  'country.PY': 'Paraguay',
  'country.PE': 'Perú',
  'country.PR': 'Puerto Rico',
  'country.BL': 'San Bartolomé',
  'country.KN': 'San Cristóbal y Nieves',
  'country.LC': 'Santa Lucía',
  'country.MF': 'San Martín',
  'country.PM': 'San Pedro y Miquelón',
  'country.VC': 'San Vicente y las Granadinas',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Surinam',
  'country.TT': 'Trinidad y Tobago',
  'country.TC': 'Islas Turcas y Caicos',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'Islas Vírgenes de los Estados Unidos',
  'country.AF': 'Afganistán',
  'country.AZ': 'Azerbaiyán',
  'country.BH': 'Baréin',
  'country.BD': 'Bangladés',
  'country.AE': 'Emiratos Árabes Unidos',
  'country.BN': 'Brunéi',
  'country.BT': 'Bután',
  'country.CN': 'China',
  'country.TL': 'Timor Oriental',
  'country.ID': 'Indonesia',
  'country.AM': 'Armenia',
  'country.PH': 'Filipinas',
  'country.PS': 'Palestina',
  'country.GE': 'Georgia',
  'country.KR': 'Corea del Sur',
  'country.IN': 'India',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Irak',
  'country.IR': 'Irán',
  'country.IL': 'Israel',
  'country.JP': 'Japón',
  'country.KH': 'Camboya',
  'country.QA': 'Catar',
  'country.KZ': 'Kazajistán',
  'country.KG': 'Kirguistán',
  'country.CY': 'Chipre',
  'country.KW': 'Kuwait',
  'country.KP': 'Corea del Norte',
  'country.LA': 'Laos',
  'country.LB': 'Líbano',
  'country.MO': 'Macao',
  'country.MV': 'Maldivas',
  'country.MY': 'Malasia',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongolia',
  'country.NP': 'Nepal',
  'country.UZ': 'Uzbekistán',
  'country.PK': 'Pakistán',
  'country.SG': 'Singapur',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Siria',
  'country.SA': 'Arabia Saudita',
  'country.TJ': 'Tayikistán',
  'country.TH': 'Tailandia',
  'country.TW': 'Taiwán',
  'country.TM': 'Turkmenistán',
  'country.OM': 'Omán',
  'country.JO': 'Jordania',
  'country.VN': 'Vietnam',
  'country.YE': 'Yemen',
  'country.DZ': 'Argelia',
  'country.AO': 'Angola',
  'country.BJ': 'Benín',
  'country.BW': 'Botsuana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Cabo Verde',
  'country.CM': 'Camerún',
  'country.CF': 'República Centroafricana',
  'country.TD': 'Chad',
  'country.KM': 'Comoras',
  'country.CG': 'República del Congo',
  'country.CD': 'República Democrática del Congo',
  'country.CI': 'Costa de Marfil',
  'country.DJ': 'Yibuti',
  'country.EG': 'Egipto',
  'country.GQ': 'Guinea Ecuatorial',
  'country.ER': 'Eritrea',
  'country.SZ': 'Esuatini',
  'country.ET': 'Etiopía',
  'country.GA': 'Gabón',
  'country.GM': 'Gambia',
  'country.GH': 'Ghana',
  'country.GN': 'Guinea',
  'country.GW': 'Guinea-Bisáu',
  'country.KE': 'Kenia',
  'country.LS': 'Lesoto',
  'country.LR': 'Liberia',
  'country.LY': 'Libia',
  'country.MG': 'Madagascar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauritania',
  'country.MU': 'Mauricio',
  'country.YT': 'Mayotte',
  'country.MA': 'Marruecos',
  'country.MZ': 'Mozambique',
  'country.NA': 'Namibia',
  'country.NE': 'Níger',
  'country.NG': 'Nigeria',
  'country.RE': 'Reunión',
  'country.RW': 'Ruanda',
  'country.SH': 'Santa Elena',
  'country.ST': 'Santo Tomé y Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seychelles',
  'country.SL': 'Sierra Leona',
  'country.SO': 'Somalia',
  'country.ZA': 'Sudáfrica',
  'country.SS': 'Sudán del Sur',
  'country.SD': 'Sudán',
  'country.TZ': 'Tanzania',
  'country.TG': 'Togo',
  'country.TN': 'Túnez',
  'country.UG': 'Uganda',
  'country.EH': 'Sahara Occidental',
  'country.ZM': 'Zambia',
  'country.ZW': 'Zimbabue',
  'country.AU': 'Australia',
  'country.CX': 'Isla de Navidad',
  'country.CC': 'Islas Cocos',
  'country.CK': 'Islas Cook',
  'country.FJ': 'Fiyi',
  'country.PF': 'Polinesia Francesa',
  'country.GU': 'Guam',
  'country.HM': 'Islas Heard y McDonald',
  'country.KI': 'Kiribati',
  'country.MH': 'Islas Marshall',
  'country.FM': 'Micronesia',
  'country.NR': 'Nauru',
  'country.NC': 'Nueva Caledonia',
  'country.NZ': 'Nueva Zelanda',
  'country.NU': 'Niue',
  'country.NF': 'Isla Norfolk',
  'country.MP': 'Islas Marianas del Norte',
  'country.PW': 'Palaos',
  'country.PG': 'Papúa Nueva Guinea',
  'country.PN': 'Islas Pitcairn',
  'country.WS': 'Samoa',
  'country.SB': 'Islas Salomón',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis y Futuna',
  'country.AQ': 'Antártida',
  'country.BV': 'Isla Bouvet',
  'country.IO': 'Territorio Británico del Océano Índico',
  'country.TF': 'Tierras Australes Francesas',
  'country.GS': 'Georgia del Sur y las Islas Sandwich del Sur',
}; 